<template>
  <el-dialog
      title="留言信息"
      :visible.sync="dialogVisible"
      @open="getCategory"
      @close="handleClose"
      >
    <el-descriptions :model="form" >
      <el-descriptions-item label="姓名" >{{form.name}}</el-descriptions-item>
      <el-descriptions-item label="手机号">{{form.phone}}</el-descriptions-item>
      <el-descriptions-item label="邮箱">{{form.email}}</el-descriptions-item>
      <el-descriptions-item label="公司" span="3">{{form.company}}</el-descriptions-item>
      <el-descriptions-item label="留言"><div style="white-space: pre-wrap;">{{form.message}}</div></el-descriptions-item>
    </el-descriptions>


    <el-button @click="handleClose">关闭</el-button>
  </el-dialog>

</template>

<script>
import axios from "axios";

export default {
  name: "getMessageView",
  data(){
    return{
      dialogVisible:this.show,
      form: {}
    }
  },
  watch:{
    show(val){
      this.dialogVisible = val
      // this.resetData();
    }
  },
  props:{
    show: {
      type: Boolean,
      default: false
    },
    id:{
      type: [String,Number],
      default: '0'
    }
  },
  // created() {
  //   this.getCategory();
  // },
  methods:{
    getCategory() {
      let id = this.$props.id;
      axios.get('/api/Category/easyList.html?id='+id).then((res)=>{
        this.cateList = res.data;
      });


      if(id > 0){
        axios.get('/api/Message/getMessage.html?id='+id).then((res)=>{
          if(res.data.code == 200){
            this.form = res.data.data;
          }
        });
      }
    },
    resetData(){
      this.form = this.$options.data().form;
    },
    handleClose() {
      this.$emit("dialogShowChange",false);
      this.resetData()
    },
    handleAvatarSuccess(res) {
      let array = Object.values(res);
      this.form.cate_img = array[0]['file_url'];
    },
    handleChange(value) {
      console.log(value);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },

    onSubmit() {
      axios({
        method:'post',
        url:'/api/Category/setCate.html',
        data:this.form
      }).then((res)=>{
        if(res.data.code != 200) {

          alert(res.data.msg);
        }
        else{
          alert(res.data.msg);
          // this.$props.id = res.data.id;
          // this.form.id = res.data.id;
          this.$router.go(0);
        }
      })
    },
  }
}
</script>

<style scoped>

</style>